import NotFoundError from 'components/views/errors/NotFoundError';

export default function ErrorLayout(props: any) {
	return(

		<NotFoundError />
	)
}